import {ReactElement} from "react";

const CDN = import.meta.env.VITE_CDN_URL;

function AuthHeaderLogo(): ReactElement {
    return (
        <div className="auth-header-logo">
            <img
                src={`${CDN}/images/DevourPlayLogoWhite.webp`}
                alt="DevourPlay"
            />
        </div>
    );
}

export default AuthHeaderLogo;
